<template>
  <div class="form-group" v-if="fbinvisible != 'true'">
    <div class="row" :style="fblabelposition == 'right'? 'flex-direction: row-reverse;': ''">
      <div
        class="col-form-label"
        :class="fblabelposition == 'top' ? 'col-sm-12' : fblabelposition == 'center' ? 'col-sm-12 text-center' : fblabelposition == null|| undefined || '' ? 'col-sm-12' :'col-sm-2'"
        v-if="fbhidelabel !== 'true'"
      >
        <label>
          <b style="color: red;" v-if="fbrequired == 'true'">*</b>
         {{fbsupportmultiplelanguages? $helper.getWord(fblabel) :fblabel || '&nbsp;' }}
        </label>
      </div>
      <div
        :class="fblabelposition == 'top'? 'col-sm-12' : fblabelposition == 'center' ? 'col-sm-12' : (fblabelposition == null || undefined || '')? 'col-sm-12' : 'col-sm-10'"
      >
        <select
          :id="id"
          ref="select"
          class="form-control form-control-select2 col-sm-12"
          v-bind:value="value"
          :required="fbrequired == 'true' ? true: false"
          :multiple="multiple || false"
          :readonly="checkReadonly(isedit, fbsubmitcanchange,fbreadonly,approvaledit)"
        >
          <option
            v-for="(option,index) in fboptions"
            :value="option.Value"
            :key="index"
          >{{ fbsupportmultiplelanguages? $helper.getWord(option.Key):option.Key }}</option>
        </select>
        <span v-if="fbhelptext" class="form-text text-muted">{{ fbhelptext }}</span>

        <!-- <input v-if="fbreadonly" type="text" :placeholder="placeholder" class="form-control" :value="valueText" :readonly="fbreadonly == 'true' ? true : false"> -->
        <label
          v-if="isValid === false"
          id="basic-error"
          class="validation-invalid-label"
          for="basic"
        >{{ $t('ui.SYS00016') }}</label>
      </div>
    </div>
  </div>
</template>
<script>
import config from "@/config";


export default {
  // [{Key: 'a', Value: 'a'}, {Key: 'b', Value: 'b'}]
  name: "fbSelectBox",
  props: [
    "id",
    "fbsupportmultiplelanguages",
    "fblabel",
    "fbplaceholder",
    "value",
    "fbvalue",
    "fboptions",
    "fbreadonly",
    "fbsubmitcanchange",
    "fbrequired",
    "fbinvisible",
    "fblabelposition",
    "fbhelptext",
    "fbtypedetail",
    "fbtype",
    "fbcountry",
    "inDialog",
    "fbhidelabel",
    "multiple",
    "labelwidth",
    "displayField",
    "isedit",
    "approvaledit"
  ],
  data() {
    return {
      val: [],
      isValid: true,
      inited: false
    };
  },
  methods: {
    setFocus() {
      this.$refs.select.focus();
    },
    setValid(val) {
      this.isValid = val;

      if (!val) {
        $(this.$refs.select)
          .next(".select2-container")
          .addClass("invalid");
      } else {
        $(this.$refs.select)
          .next(".select2-container")
          .removeClass("invalid");
      }
    },
    isFieldValid() {
      return (
        !this.required || (this.required && this.val && this.val.length > 0)
      );
    },
    resetValue() {
      this.isValid = true;
      this.val = [];
      $(this.$refs.select)
        .val(this.val)
        .trigger("change");
    },
    checkReadonly(isedit,fbsubmitcanchange,fbreadonly,approvaledit) {
      let readonly = true;
       console.log(approvaledit);
      if(fbsubmitcanchange){
        if(approvaledit||isedit){
          readonly = false;
        }else{
          readonly = true;
        }
      }
      else if (isedit) {
        if (fbreadonly == "true") {
          readonly = true;
        } else {
          readonly = false;
        }
      } else {
        readonly = true;
      }

      return readonly;
    },
    initSelect2() {
      var opt = {
        allowClear: true
      };

      if (this.inDialog) {
        opt.dropdownParent = $(this.$el).closest(".modal");
      }

      this.$nextTick(() => {
        let $vm = this;
        var ajaxOpt = {};
        if (this.fbtype == "postcode" && this.fbcountry) {
          ajaxOpt = {
            ajax: {
              url: config.serverURI + "/api/userBuildForm/getPostCodeList",
              type: "post",
              dataType: "json",
              delay: 250,
              data: function(params) {
                var queryParameters = {
                  SessionID: $vm.$store.state.token,
                  LocaleCode: $vm.$store.state.user.locale_code,
                  Parameters: {
                    q: params.term,
                    country: $vm.fbcountry
                  },
                  ApiKey: config.apiKey,
                  ApiSystemName: config.apiSystemName
                };
                return JSON.stringify(queryParameters);
              },
              processResults: function(data, params) {
                if (data.code == 200) {
                  //console.log(data.data.lookups);
                  return {
                    results: data.data.lookups
                  };
                }
              },
              cache: true,
              headers: {
                "Content-type": "application/json; charset=utf-8"
              },
              allowClear: true
            }
          };
        } else {
          ajaxOpt = {
            allowClear: true
          };
        }

        if($vm.fbsubmitcanchange=="true"){
          if($vm.approvaledit||$vm.isedit){
      Object.assign(ajaxOpt, { disabled: false });
      }else{
          Object.assign(ajaxOpt, { disabled: true });
      }
        }else  if ($vm.isedit) {
          if ($vm.fbreadonly == "true") {
            Object.assign(ajaxOpt, { disabled: true });
          } else {
            Object.assign(ajaxOpt, { disabled: false });
          }
        } else {
          Object.assign(ajaxOpt, { disabled: true });
        }
        Object.assign(ajaxOpt, { placeholder: $vm.fbplaceholder ?? "" }); // For select2 clear bug

        setTimeout(function() {
          $($vm.$refs.select)
            .select2(ajaxOpt)
            .on("change", function() {
              let value = "";
              if($vm.fbtype == 'postcode'){
                //default browser value cannot have space character ==> prevent XSS
                //change to &#32; to insert space inside the value
                value = $(this).select2("data")[0].text.split('\n').pop().replace(/ /g, '&#32;'); 
                if($vm.fbtype == 'postcode') {
                  $($vm.$refs.select).empty();
                  $($vm.$refs.select).append(`<option value=${value}>${value}</option>`);
                }
                
                  
              }else{
                value = this.value;
              }
              
              value = value.replace(/&#32;/g, ' ');
              $vm.$emit("input", value);

              $($vm.$refs.select).val(value);
            })
            .on("select2:unselect", function(e) {
              $vm.$emit("input", undefined);
            });
        }, 250);
      });
    }
  },
  computed: {
    valueText() {
      var v = null;
      if (this.val && this.options) {
        $.each(
          this.options,
          $.proxy(function(i, o) {
            if (this.val === o.Key) {
              v = this.displayField ? o[this.displayField] : o.Value;
              return false;
            }
          }, this)
        );
      }

      return v;
    },
    labelCol() {
      return this.labelwidth || 3;
    }
  },
  mounted() {
    this.initSelect2();

    $(this.$refs.select).val(this.fbvalue).trigger('change'); //select2 value
    this.$emit('input', this.fbvalue, this);  //vue componenet value


    if(this.value != null){
      if (this.fbtype == "postcode"){
        let value = this.value.replace(/ /g, '&#32;');
        $(this.$refs.select).append(`<option value=${value}>${value}</option>`);
        value = value.replace(/&#32;/g, ' ');
      }

      this.$emit('input', this.value, this);
      $(this.$refs.select).val(this.value).trigger('change');
    }
  },
  watch: {
    isedit: function() {
      console.log('WATCHING');
      this.initSelect2();
    },
    approvaledit:function() {
      console.log('WATCHING2');
      this.initSelect2();
    },
    value: function(val) {
      $(this.$refs.select)
        .val(val)
        .trigger("change");
    }
  }
};
</script>
<style>
.select2-selection--single .select2-selection__arrow:after {
  margin-right: 10px;
}
.select2-selection__placeholder {
  font-size: 0.8rem;
}
.select2-selection__rendered {
  padding-left: 13px !important;
  padding-top: 2px;
}
.select2-selection.select2-selection--single {
  /* min-height: 35px; */
  min-height: 42px;
}
.select2-selection--single {
  padding: 5px 0;
  /* border-bottom: 0px solid !important; */
}
.select2-search--inline,
.select2-search__field {
  width: 100% !important;
}
</style>
